import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Plus, UserPlus, ClipboardList, Route, AlarmClock, MapPin, Phone,
} from 'lucide-react';

// Route → the page's PRIMARY add/create action. The FAB simply triggers the
// real header button (by data-testid) so there's a single source of truth and
// no duplicated logic. Only shows when that button actually exists in the DOM
// (it may be role-gated on some pages).
const MAP = {
  '/leads': { testid: 'add-lead-btn', label: 'Add Lead', icon: UserPlus },
  '/task-tracker': { testid: 'create-task-btn', label: 'New Task', icon: ClipboardList },
  '/places': { testid: 'add-place-btn', label: 'Add Place', icon: MapPin },
  '/sales-points': { testid: 'add-sales-point-btn', label: 'Add Point', icon: MapPin },
  '/team': { testid: 'add-team-member-btn', label: 'Add Member', icon: UserPlus },
  '/travel-plans': { testid: 'create-plan-btn', label: 'New Plan', icon: Route },
  '/reminders': { testid: 'add-reminder-btn', label: 'New Reminder', icon: AlarmClock },
  '/sub-users': { testid: 'create-sub-user-btn', label: 'New Sub-user', icon: UserPlus },
  '/call-tracker': { testid: 'log-call-btn', label: 'Log Call', icon: Phone },
};

export const MobilePrimaryFab = () => {
  const { pathname } = useLocation();
  const cfg = MAP[pathname];
  const [ready, setReady] = useState(false);

  // Poll briefly for the target button (pages lazy-render / role-gate it).
  useEffect(() => {
    setReady(false);
    if (!cfg) return undefined;
    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      const el = document.querySelector(`[data-testid="${cfg.testid}"]`);
      if (el) { setReady(true); clearInterval(id); }
      else if (tries > 12) clearInterval(id); // ~3.6s
    }, 300);
    return () => clearInterval(id);
  }, [pathname, cfg]);

  if (!cfg || !ready) return null;

  const trigger = () => {
    const el = document.querySelector(`[data-testid="${cfg.testid}"]`);
    if (el) el.click();
  };

  const Icon = cfg.icon || Plus;
  return (
    <button
      type="button"
      data-testid="mobile-primary-fab"
      onClick={trigger}
      aria-label={cfg.label}
      className="md:hidden fixed right-4 z-40 flex items-center gap-2 pl-4 pr-5 h-12 rounded-full bg-amber-600 text-white font-bold text-sm shadow-lg shadow-amber-600/40 active:scale-95 transition-transform animate-in slide-in-from-bottom-4 fade-in"
      style={{ bottom: 'calc(env(safe-area-inset-bottom) + 72px)' }}
    >
      <Icon className="w-5 h-5" strokeWidth={2.3} />
      {cfg.label}
    </button>
  );
};

export default MobilePrimaryFab;
